import { render } from "./CreateActionFromBarrierPopup.vue?vue&type=template&id=719b1332&scoped=true"
import script from "./CreateActionFromBarrierPopup.vue?vue&type=script&lang=js"
export * from "./CreateActionFromBarrierPopup.vue?vue&type=script&lang=js"

import "./CreateActionFromBarrierPopup.vue?vue&type=style&index=0&id=719b1332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719b1332"]])

export default __exports__